"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingType = void 0;
/**
 * LandingType controls the applications that are available for users
 * to go through from the Loan Officer's Landing page (PreQual Express)
 */
var LandingType;
(function (LandingType) {
    LandingType["AUTO_LOAN"] = "AUTO_LOAN";
    LandingType["COMMERCIAL"] = "COMMERCIAL";
    LandingType["CREDIT_CARD"] = "CREDIT_CARD";
    LandingType["DOCUMENT_UPLOADER"] = "DOCUMENT_UPLOADER";
    LandingType["HOME_EQUITY"] = "HOME_EQUITY";
    LandingType["HOME_EQUITY_TURBO"] = "HOME_EQUITY_TURBO";
    LandingType["MORTGAGE"] = "MORTGAGE";
    LandingType["OTHER_VEHICLES"] = "OTHER_VEHICLES";
    LandingType["OVERDRAFT_PROTECTION"] = "OVERDRAFT_PROTECTION";
    LandingType["PERSONAL_LOAN"] = "PERSONAL_LOAN";
    LandingType["PURCHASE_TURBO"] = "PURCHASE_TURBO";
    LandingType["REFINANCE_TURBO"] = "REFINANCE_TURBO";
    LandingType["PRE_QUAL"] = "PRE_QUAL";
    LandingType["REVERSE_MORTGAGE"] = "REVERSE_MORTGAGE";
    LandingType["SHORT_PURCHASE"] = "SHORT_PURCHASE";
    LandingType["SHORT_REFINANCE"] = "SHORT_REFINANCE";
})(LandingType = exports.LandingType || (exports.LandingType = {}));
